import { BidQueuedPlanRefuelingsViewModel, OrganizationProfileModel } from "api";
import { featureModuleTypesEnum } from "helpers/enums";
import { IUserModel } from "helpers/models/user";
import { RolesModel } from "helpers/roles";
import BidPolicy from "./bidPolicy";
import PathPolicy from "./pathPolicy";
import UserPolicy from "./userPolicy";

export type PolicyOptionsModel = {
    availableFeatureModules?: (keyof typeof featureModuleTypesEnum)[];
    isFuelLimitEnabled?: boolean;
    book?: string;
    action?: string;
    isPublic?: boolean;
    refueling?: BidQueuedPlanRefuelingsViewModel;
    isOpened?: boolean;
    distance?: number;
    limitedFunctionality?: boolean;
    refuelingSettings?: { hideRefuelingPlanning: boolean };
};
export type PunditUser = {
    profile?: IUserModel;
    organization?: OrganizationProfileModel;
    canEditAll?: boolean;
    intBooksEditPermissionsFlags?: number;
    roles: RolesModel;
    allowedReports?: Array<string>;
    isDemoPeriodExpired?: boolean;
};

const policyMapper = {
    path: PathPolicy,
    user: UserPolicy,
    bid: BidPolicy,
};

export default function (
    type: keyof typeof policyMapper,
    args: {
        user: PunditUser;
        record: any;
        options: PolicyOptionsModel;
    },
) {
    return new policyMapper[type](args) as unknown as { [x: string]: () => boolean };
}
